import { render, staticRenderFns } from "./ActivityGrid.vue?vue&type=template&id=362ae4a5&scoped=true&"
import script from "./ActivityGrid.vue?vue&type=script&lang=js&"
export * from "./ActivityGrid.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGrid.vue?vue&type=style&index=0&id=362ae4a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ae4a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362ae4a5')) {
      api.createRecord('362ae4a5', component.options)
    } else {
      api.reload('362ae4a5', component.options)
    }
    module.hot.accept("./ActivityGrid.vue?vue&type=template&id=362ae4a5&scoped=true&", function () {
      api.rerender('362ae4a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityGrid.vue"
export default component.exports